import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./Components/Protected Route/ProtectedRoute";
import InternalServerError from "./Components/Errors Handling/Error 500/InternalServerError.jsx";
import Error404 from "./Components/Errors Handling/Error 404/Error404.jsx";
import Layout from "./Components/layout/Layout.jsx";
import CenterLoader from "./Components/CenterLoader/CenterLoader.jsx"; // renamed from SlugChecker
import AuthForm from "./Components/Screens/Login/auth.jsx";
import Home from "./Components/Screens/Home/Home.jsx";
import Booking from "./Components/Screens/Booking/Booking.jsx";
import MyBookings from "./Components/Screens/MyBookings/MyBookings.jsx";
import UserProfile from "./Components/Screens/UserProfile/UserPRofile.jsx";
import Settings from "./Components/Screens/Settings/SettingsScreen.jsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ScheduleManagement from "./Components/Screens/Reminer/Reminder.jsx";
import MyReports from "./Components/Screens/Reports/MyReports.jsx";
import OurDoctors from "./Components/HomeSections/OurDoctors.jsx";
import BlogDetails from "./Components/Screens/BlogDetails/BlogDetails.jsx";
import { LanguageProvider } from "./context/LanguageContext.js";
import NewComingSoon from "./Components/Screens/CommingSoon/NewCommingSoon.jsx";
import DoctorDetailsPage from "./Components/Screens/DoctorDetails/DoctorDetails.jsx";
import { HelmetProvider } from "react-helmet-async";
import ContactUs from "./Components/HomeSections/ContactUS.jsx";
import ClinicsSection from "./Components/HomeSections/DoctorInfo.jsx";
import OurServices from "./Components/HomeSections/OurServices.jsx";
import PackagePurchase from "./Components/HomeSections/Packages.jsx";
import NewsSection from "./Components/HomeSections/OurNews.jsx";
import BlogsSection from "./Components/HomeSections/BlogsSection.jsx";
import ReviewClinicScreen from "./Components/Screens/ReviewScreen/ReviewScreen.jsx";
import { DoctorContextProvider } from "./context/DoctorContext.js";
import PublicReview from "./Components/Screens/PublicReview/PublicReview.jsx";
import MyInvoicesScreen from "./Components/Screens/MyInvoices/MyInvoices.jsx";

function App() {
  const routers = createBrowserRouter([
    {
      path: "/",
      element: <CenterLoader />,   // wraps everything, fetches center data once
      children: [
        { path: "auth", element: <AuthForm /> },
        { path: "login", element: <AuthForm active={"login"} /> },
        { path: "sign-up", element: <AuthForm active={"signup"} /> },
        {
          path: "",
          element: <Layout />,
          children: [
            { index: true, element: <Home /> },
            { path: "home", element: <Home /> },
            { path: "contact-us", element: <ContactUs /> },
            { path: "book-appointment", element: <Booking /> },
            { path: "blog/:id", element: <BlogDetails /> },
            { path: "services", element: <OurServices /> },
            { path: "packages", element: <PackagePurchase /> },
            { path: "news", element: <NewsSection /> },
            { path: "blogs", element: <BlogsSection /> },
            { path: "clinics", element: <ClinicsSection /> },
            { path: "our-doctors", element: <OurDoctors /> },
            { path: "doctor-details", element: <DoctorDetailsPage /> },
            { path: "review-clinic", element: <ReviewClinicScreen /> },
            { path: "review/:centerId", element: <PublicReview /> },
            {
              path: "my-appointments",
              element: <ProtectedRoute><MyBookings /></ProtectedRoute>,
            },
            {
              path: "schedule-reminder",
              element: <ProtectedRoute><ScheduleManagement /></ProtectedRoute>,
            },
            {
              path: "user-profile",
              element: <ProtectedRoute><UserProfile /></ProtectedRoute>,
            },
            {
              path: "my-reports",
              element: <ProtectedRoute><MyReports /></ProtectedRoute>,
            },
            {
              path: "settings",
              element: <ProtectedRoute><Settings /></ProtectedRoute>,
            },
            {
              path: "invoices",
              element: <ProtectedRoute><MyInvoicesScreen /></ProtectedRoute>,
            },
          ],
        },
      ],
    },
    { path: "coming-soon", element: <NewComingSoon /> },
    { path: "server-error", element: <InternalServerError /> },
    { path: "not-found", element: <Error404 /> },
    { path: "*", element: <Error404 /> },
  ]);

  return (
    <HelmetProvider>
      <DoctorContextProvider>
      <GoogleOAuthProvider clientId="540631881814-0fv2ofvnb2tsb002i7n917it0moe6ev0.apps.googleusercontent.com">
        <LanguageProvider>
          <RouterProvider router={routers} />
        </LanguageProvider>
      </GoogleOAuthProvider>
      </DoctorContextProvider>
    </HelmetProvider>
  );
}

export default App;